import React from 'react';

export default class Input extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            error: null
        }
    }

    defaultChangeHandler(e) {
        this.setState({
            value: e.target.value
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    validate(rule, errorMsg) {
        if (!rule(this.state.value)) {
            this.setState({
                error: errorMsg
            });
            return false;
        }

        this.setState({
            error: null
        });

        return true;
    }

    render() {
        const {changeHandler, label, value, validate, ...props} = this.props;
        const error = this.state.error || this.props.error;

        // value, placeholder, className, id, type, name, required
        return <div className="input-holder">
            <label htmlFor={props.id}>{label}</label>
            {error ? <div className="msg-error">{error}</div> : null}
            {label ? <input value={this.state.value}
                            onChange={changeHandler || this.defaultChangeHandler.bind(this)} {...props} /> : null}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Forms/Input.js